import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import { IconButton, colors } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export default function DraggableDialog(props) {
    const { children, open, buttonText, title, onButtonClose } = props
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('md');

    const handleClose = () => {
        props.closeDialog(false)
    };
    return (
        <div>

            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
            // sx={{ zIndex: 10001 }}
            >
                <DialogTitle id="draggable-dialog-title" sx={{ fontFamily: "Customfont !important", cursor: 'move' }}>
                    {title === "" ? 'แจ้งเตือน' : title}

                    {onButtonClose ? (
                        <Button
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                zIndex: 'inherit'
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    ) : null}

                </DialogTitle>
                <DialogContent>
                    {children}
                </DialogContent>
            </Dialog>
        </div >
    );
}

DraggableDialog.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.node,
    buttonText: PropTypes.string,
    title: PropTypes.string
} 